import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div class="poem">
      <p class="poem-block mb-5 text-center">* * *</p>
      
      <p class="poem-block mb-3">
        Кончается ветер…<br/>
        Устало ложится<br/>
        На пыльную землю,<br/>
        И нет больше силы. <br/>
        То крыши срывал он, <br/>
        То, будто бы спички, <br/>
        Ломал он деревья…<br/>
        А нынче нет силы, <br/>
        Всё кончилось, сдулось.<br/>
        И словно больная собака,<br/>
        Забился ветер под листья. 
      </p>
      
    </div>
    `
  )
}

const itemName = {
  rus: 'Кончается ветер'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;
